import Vue from "vue";

export const diagramPlugins = (state, data) => {
    state.diagramPlugins = data;
};

export const selectedPluginCode = (state, data) => {
    state.selectedPluginCode = data;
};

export const setParallelHTCheckbox = (state, data) => {
    state.parallelHTCheckbox = data;
};

export const selectedPluginUuid = (state, data) => {
    state.selectedPluginUuid = data;
};

export const setExternalMapReqData = (state, data) => {
    state.externalMapReqData = data;
};

export const setExternalDraftDataEmail = (state, data) => {
    state.externalDraftDataEmail = data;
};
export const setExternalDraftDataSMS = (state, data) => {
    state.externalDraftDataSMS = data;
};
export const setExternalDraftDataEmailAuth = (state, data) => {
    state.externalDraftDataEmailAuth = data;
};

export const setIsFromResponse = (state, data) => {
    state.isFromResponse = data;
};

export const setLastPluginCreated = (state, payload) => {
    state.lastPluginCreated = payload;
};

export const setAllAppi = (state, data) => {
    state.setAllAppi = data;
};
export const apiParam = (state, data) => {
    state.apiParam = data;
};
export const setAllResponse = (state, data) => {
    state.setAllResponse = data;
};
export const setAllResponseCallApi = (state, data) => {
    state.setAllResponseCallApi = data;
};
export const setAllErrors = (state, data) => {
    state.setAllErrors = data;
};
export const setAllRequest = (state, data) => {
    state.setAllRequest = data;
};
export const setAllRequestCallApi = (state, data) => {
    state.setAllRequestCallApi = data;
};
export const setHasNewComments = (state, data) => {
    state.hasNewComments = data;
};
export const diagramData = (state, data) => {
    if (data && data.connectors) {
        state.diagramData.connectors = data.connectors;
    }

    if (data && data.content) {
        state.diagramData.content = data.content;
    }

    if (data && data.gridView) {
        state.diagramData.gridView = data.gridView;
    }

    if (data && data.worldData) {
        state.diagramData.worldData = data.worldData;
    }
};

export const diagramConfigData = (state, data) => {
    if (data) {
        state.diagramConfigData = data;
        if (!state.copyOfInitialContentDiagram.length) {
            state.copyOfInitialContentDiagram = JSON.stringify(data.content);
        }
        if (!state.copyOfInitialConnectorsDiagram.length) {
            state.copyOfInitialConnectorsDiagram = JSON.stringify(data.connectors);
        }
        if (!state.copyOfInitialMessagesDiagam.length) {
            state.copyOfInitialMessagesDiagam = JSON.stringify(data.messages);
        }
    }
};

export const setCopyOfInitialContentDiagram = (state, payload) => {
    state.copyOfInitialContentDiagram = payload;
};

export const setCopyOfInitialConnectorsDiagram = (state, payload) => {
    state.copyOfInitialConnectorsDiagram = payload;
};

export const setCopyOfInitialMessagesDiagam = (state, payload) => {
    state.copyOfInitialMessagesDiagam = payload;
};

export const configCache = (state, data) => {
    state.configCache = data;
};

export const setProcessWithError = (state, payload) => {
    state.processWithError = payload;
};

export const addNewConfigObject = (state, data) => {
    if (data.type && data.type === "connector") {
        data.type = "connectors";
    }

    state.diagramConfigData[data.type || "content"].push(data.payload);
};

/**
 *
 * @param {*} state - store state
 * @param {Object} data - contains info about what to configure and it's data
 * @param {String} data.uuid - uuid of what to add/update
 * @param {String} data.type - optional, what type to add/update - use one of content or connector
 * @param {String} data.property - property name to add in the config object
 * @param {any} data.value - value to set
 */
export const setConfigData = (state, data) => {
    if (data.type && data.type === "connector") {
        data.type = "connectors";
    }

    if (!data.uuid) {
        throw new Error("uuid not set");
    }

    const configData = state.diagramConfigData[data.type || "content"];

    for (let i = 0; i < configData.length; i++) {
        if (configData[i].uuid === data.uuid) {
            Vue.set(configData[i], data.property, data.value);
            break;
        }
    }
};

export const addConfigToCache = (state, data) => {
    if (data.type && data.type === "connector") {
        data.type = "connectors";
    }

    const configData = state.diagramConfigData[data.type || "content"];
    for (let i = 0; i < configData.length; i++) {
        if (configData[i].uuid === data.uuid) {
            state.configCache[data.type || "content"][data.uuid] = configData[i];
        }
    }
};

export const setGuiForProcessDefinition = (state, data) => {
    state.guiForProcessDefinition = data;
};

export const setModelForProcessDefinition = (state, data) => {
    state.modelForProcessDefinition = data;
};

export const setVariables = (state, data) => {
    state.variables = data;
};

export const setExternalTask = (state, data) => {
    state.externalTask.push(data);
};

export const addMessageToConfig = (state, data) => {
    let found = false;

    for (let i = 0; i < state.diagramConfigData.messages.length; i++) {
        if (state.diagramConfigData.messages[i].id === data.id) {
            state.diagramConfigData.messages[i] = { ...data };
            found = true;
        }
    }

    if (!found) {
        state.diagramConfigData.messages.push(data);
    }
};
export const setUrl = (state, data) => {
    state.externalStartUrl = data;
};
export const setSCDetailsFunction = (state, data) => {
    state.scDetailsFunction = data;
};
export const setSCDetailsEvent = (state, data) => {
    state.scDetailsEvent = data;
};

export const setUrlExpose = (state, data) => {
    state.exposeStartUrl = data;
};
export const setTatData = (state, data) => {
    state.tatData = data;
};

export const setAuditTrails = (state, data) => {
    state.auditTrails = data;
};

export const setActivities = (state, data) => {
    state.activities = data;
};

export const setProcesses = (state, data) => {
    state.activeProcesses = data;
    state.activeProcessesCount = data.object.length;
};

export const setAuditTrail = (state, data) => {
    state.auditTrail = data;
};

export const setDocumentsList = (state, data) => {
    state.documentsList = data;
};

export const setExternalTaskMessages = (state, messages) => {
    if (messages.add) {
        state[messages.externalMessageType].push(messages.data);
    } else if (messages.edit) {
        state[messages.externalMessageType][messages.index] = messages.data;
    } else if (messages.delete) {
        state[messages.externalMessageType].splice(messages.index, 1);
    } else {
        state[messages.externalMessageType] = messages.data;
    }
};

export const setDiagramStateModifications = (state, data) => {
    state.diagramStateModifications = data && data.payload ? data.payload : [];
};

export const setConnectorsValidation = (state, data) => {
    state.connectorsValidation = data || [];
};

export const checkConnectorsUUIDs = (state, data) => {
    if (state.connectorsValidation.length) {
        state.connectorsValidation.forEach(element => {
            if (data.payload) {
                if (data.payload.CONNECTOR_UUID === element) {
                    state.connectorsValidation.splice(state.connectorsValidation.indexOf(element), 1);
                }
            } else if (data.uuid) {
                if (data.uuid === element) {
                    state.connectorsValidation.splice(state.connectorsValidation.indexOf(element), 1);
                }
            }
        });
    }
};
// set warning list on publish application
export const setWarningsList = (state, data) => {
    state.warningOnApp = data || [];
};

// set timeline tasks details
export const setTimelineTaskDetails = (state, details) => {
    if (details) {
        state.allTimelineTaskDetails.push(details);
    } else {
        state.allTimelineTaskDetails = [];
    }
};

// set timeline approval matrix level tasks details
export const setTimelineApprovalLevelDetails = (state, details) => {
    if (details) {
        state.allTimelineAppLevelDetails.push(details);
    } else {
        state.allTimelineAppLevelDetails = [];
    }
};
export const setDiagramFileNameWithDataModel = (state, data) => {
    state.diagramFileNameWithDataModel = data;
};
